module.exports = __webpack_public_path__ + "static/media/Descubriendo tu Liderazgo.9b2eecf9.pdf";